import { onDocumentLoaded } from '@theme/utilities';

/**
 * Opens the custom mega menu overlay for the clicked header menu item.
 */
function initCustomMegaMenu() {
  const dialogComponent = document.getElementById('mega-menu-modal');
  if (!dialogComponent) return;

  const dialog = dialogComponent.querySelector('dialog');

  // Pin the overlay to the header's real bottom edge so there is no gap.
  // Note: when the header is sticky, #header-group becomes `display: contents`
  // and reports a zero-size box, so measure the visible header sections instead.
  function positionMega() {
    const candidates = document.querySelectorAll(
      '#header-group .header-section, #header-group #header-component, #header-group'
    );
    let bottom = 0;
    candidates.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
    });
    if (bottom <= 0) {
      dialogComponent.style.removeProperty('--soharie-mega-top');
      return;
    }
    dialogComponent.style.setProperty('--soharie-mega-top', `${Math.round(bottom)}px`);
  }

  function handleReposition() {
    if (dialog?.open) positionMega();
  }

  window.addEventListener('resize', handleReposition);
  window.addEventListener('scroll', handleReposition, { passive: true });

  /** @param {string} key */
  function showPanel(key) {
    dialogComponent.querySelectorAll('[data-mega-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.megaPanel !== key;
    });

    document.querySelectorAll('[data-mega-menu-trigger]').forEach((trigger) => {
      const isActive = trigger.dataset.megaMenuTrigger === key;
      trigger.classList.toggle('is-mega-active', isActive);
      if (trigger instanceof HTMLElement) {
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  }

  function clearActive() {
    document.querySelectorAll('[data-mega-menu-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-mega-active');
      if (trigger instanceof HTMLElement) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-mega-menu-trigger]');
    if (!trigger) return;

    const key = trigger.dataset.megaMenuTrigger;
    if (!key) return;

    const panel = dialogComponent.querySelector(`[data-mega-panel="${key}"]`);
    if (!panel) return;

    event.preventDefault();
    positionMega();
    showPanel(key);

    if (dialog && !dialog.open && typeof dialogComponent.showDialog === 'function') {
      dialogComponent.showDialog();
    }
  });

  dialog?.addEventListener('close', clearActive);
}

onDocumentLoaded(initCustomMegaMenu);
